import { useEffect, useState } from "react";
import Input from "../../components/InputBox";
import Select from "../../components/SelectInput";
import CheckboxGroup from "../../components/Checkbox";
import { getGlobalOptions } from "../../services/auth/selfSignUp";
import { enumGlobalOptionData } from "../../utils/enumGlobalOptionData";
import { convertForSelect } from "../../utils/convertApiData";
import { toast } from "../../components/AppToast";

const languageOptions = [
    { label: "Hindi", value: "1" },
    { label: "English", value: "2" },
];

const ContactsPage = ({ formData, setFormData, dataFor }) => {
    const [titleOptions, setTitleOption] = useState([]);
    const contact = formData?.contact?.[0] || {};

    const getTitleData = async () => {
        try {
            const data = await getGlobalOptions(enumGlobalOptionData.TITLE);
            setTitleOption(convertForSelect(data));
        } catch (err) {
            toast.error(err);
        }
    };

    useEffect(() => {
        getTitleData();
    }, []);

    const updateContact = (patch) => {
        setFormData({
            ...formData,
            contact: [{ id: contact.id || 1, ...contact, ...patch }],
        });
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        updateContact({ [name]: value });
    };

    return (
        <div className="card_content">
            <h4>Step 4: Contacts Page</h4>
            <p>Fill all the mandatory fields details here.</p>
            <div className="card_container">
                <Select
                    isRequired
                    options={titleOptions}
                    className="select-input"
                    label="Title"
                    name={`${dataFor}_title`}
                    value={contact?.[`${dataFor}_title`] || ""}
                    onChange={onChange}
                />
                <Input
                    isRequired
                    className="input"
                    label="First Name"
                    name={`${dataFor}_firstName`}
                    value={contact?.[`${dataFor}_firstName`] || ""}
                    onChange={onChange}
                />
                <Input
                    isRequired
                    className="input"
                    label="Last Name"
                    name={`${dataFor}_lastName`}
                    value={contact?.[`${dataFor}_lastName`] || ""}
                    onChange={onChange}
                />
                <Input
                    isRequired
                    className="input"
                    label="Designation"
                    name={`${dataFor}_designation`}
                    value={contact?.[`${dataFor}_designation`] || ""}
                    onChange={onChange}
                />
                <Input
                    isRequired
                    className="input"
                    type="email"
                    label="Email"
                    name={`${dataFor}_email`}
                    value={contact?.[`${dataFor}_email`] || ""}
                    onChange={onChange}
                />
                <Input
                    isRequired
                    className="input"
                    type="tel"
                    label="Phone Number"
                    name={`${dataFor}_phone`}
                    value={contact?.[`${dataFor}_phone`] || ""}
                    onChange={onChange}
                />
                <div className="onboarding-admin-toggle">
                    <CheckboxGroup
                        options={[{ label: "Admin User", value: "admin" }]}
                        name="admin_user"
                        values={contact?.admin_user ? ["admin"] : []}
                        onChange={(newValues, checked) =>
                            updateContact({ admin_user: checked })
                        }
                    />
                </div>

                {contact?.admin_user && (
                    <>
                        <span className="form_title" style={{ width: "100%" }}>Trangile Partner Portal Admin login credentials</span>
                        <Input
                            isRequired
                            className="input"
                            label="Login Id"
                            name={`${dataFor}_adminLoginId`}
                            value={contact?.[`${dataFor}_adminLoginId`] || ""}
                            onChange={onChange}
                        />
                        <Input
                            isRequired
                            className="input"
                            label="Login Password"
                            name={`${dataFor}_adminLoginPassword`}
                            value={contact?.[`${dataFor}_adminLoginPassword`] || ""}
                            onChange={onChange}
                        />
                        <Select
                            isRequired
                            options={languageOptions}
                            className="select-input"
                            label="Language"
                            name={`${dataFor}_language`}
                            value={contact?.[`${dataFor}_language`] || ""}
                            onChange={onChange}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ContactsPage;
